import http from './http';

export async function listSorties(params) {
  const { data } = await http.get('/sorties', { params });
  return data; // { items, total, page, pageSize }
}

export async function listSortiesCount(params) {
  const { data } = await http.get('/sorties/count', { params });
  return data; // { total }
}

export async function approveSortie(id) {
  const { data } = await http.post(`/sorties/${id}/approve`);
  return data;
}

export async function refuseSortie(id) {
  const { data } = await http.post(`/sorties/${id}/refuse`);
  return data;
}

export async function scanOut(id) {
  const { data } = await http.post(`/sorties/${id}/scan-out`);
  return data;
}

export async function scanIn(id) {
  const { data } = await http.post(`/sorties/${id}/scan-in`);
  return data;
}

// Student
export async function createMySortie(payload) {
  const { data } = await http.post('/sorties', payload);
  return data;
}

export async function listMySorties() {
  const { data } = await http.get('/sorties/mine');
  return data;
}

export async function listMySortiesCount(params) {
  const { data } = await http.get('/sorties/mine/count', { params });
  return data; // { total }
}

export async function exportSortiesCsv(params) {
  const res = await http.get('/sorties/export', { params, responseType: 'blob' });
  return res.data; // Blob
}

export async function listSortiesHoursSummary(params) {
  const { data } = await http.get('/sorties/hours-summary', { params });
  return data; // { items, total, page, pageSize, totalPages }
}
